import React from 'react';
import { Backdrop, CircularProgress } from '@material-ui/core';
import useStyles from '../../../styles';

export default function LoadingBackdrop(props) {
    const classes = useStyles();

    return (
        <Backdrop {...props} className={classes.loadingBackdrop}>
            <CircularProgress color="inherit" />
        </Backdrop>
    );
}